"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.doCarritoCotiDiscounts = exports.doCarritoCotiPrice = exports.doCarritoCotiClear = exports.doCarritoCotiRemove = exports.doCarritoCotiList = exports.doCarritoCotiAdd = exports.doCarritoSobreDiscount = exports.doCarritoMerch = exports.doCarritoDiscounts = exports.doCarritoPrice = exports.doCarritoAffect = exports.doCarritoConfirm = exports.doCarritoList = exports.doCarritoClear = exports.doCarritoRemove = exports.doCarritoAdd = void 0;
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const api_1 = __importDefault(require("constants/api"));
const constants_1 = require("constants/constants");
const model_1 = require("constants/model");
const fetch_1 = require("./fetch");
let controller = new AbortController();
const doCarritoAdd = async ({ params, callback }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    const clientDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.CLIENT_DATA);
    const clientDataJSON = JSON.parse(clientDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "carrito",
        token: loginDataJSON.token,
        fnc: model_1.ShoppingCart.FNC_ADD,
        cliid: params?.clientId || clientDataJSON.id,
        tipo: params?.tipo ?? "ped",
        almacen: params?.almacen,
        data: {
            procodigo: params?.data?.procodigo, //código del producto a agregar
            cantidad: params?.data?.cantidad,
            stockAlert: params?.data?.stockAlert,
            stockAlertFecha: params?.data?.stockAlertFecha,
            stockAlertReason: params?.data?.stockAlertReason,
            stockAlertReasonType: params?.data?.stockAlertReasonType,
            stockAlertColor: params?.data?.stockAlertColor,
        },
    }));
    controller.abort();
    controller = new AbortController();
    const { signal } = controller;
    callback?.onLoading?.(true);
    fetch(api_1.default.URL_BASE, {
        signal: signal,
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response?.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                if (json?.reason == api_1.default.REASON_SESSION_EXIPIRED)
                    callback?.onFailSessionExpired?.();
                callback?.onFail?.(json.msg);
                break;
        }
        callback?.onLoading?.(false);
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
        callback?.onLoading?.(false);
    });
};
exports.doCarritoAdd = doCarritoAdd;
const doCarritoRemove = async ({ params, callback, }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    const clientDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.CLIENT_DATA);
    const clientDataJSON = JSON.parse(clientDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "carrito",
        token: loginDataJSON.token,
        fnc: model_1.ShoppingCart.FNC_REMOVE,
        cliid: params?.clientId || clientDataJSON?.id,
        tipo: params?.tipo,
        almacen: params?.almacen,
        data: {
            procodigo: params?.data?.procodigo, //código del producto a agregar
        },
    }));
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response?.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                if (json?.reason == api_1.default.REASON_SESSION_EXIPIRED)
                    callback?.onFailSessionExpired?.();
                callback?.onFail?.(json.msg);
                break;
        }
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
    });
};
exports.doCarritoRemove = doCarritoRemove;
const doCarritoClear = async ({ params, callback }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    const clientDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.CLIENT_DATA);
    const clientDataJSON = JSON.parse(clientDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "carrito",
        token: loginDataJSON.token,
        fnc: model_1.ShoppingCart.FNC_CLEAR,
        cliid: clientDataJSON.id,
        almacen: params?.almacen,
        tipo: params?.tipo,
    }));
    callback?.onLoading?.(true);
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response?.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                if (json?.reason == api_1.default.REASON_SESSION_EXIPIRED)
                    callback?.onFailSessionExpired?.();
                callback?.onFail?.(json.msg);
                break;
        }
        callback?.onLoading?.(false);
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
        callback?.onLoading?.(false);
    });
};
exports.doCarritoClear = doCarritoClear;
const doCarritoList = async ({ params, callback, }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    const clientDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.CLIENT_DATA);
    const clientDataJSON = JSON.parse(clientDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "carrito",
        token: loginDataJSON.token,
        fnc: model_1.ShoppingCart.FNC_LIST,
        cliid: params?.clientId || params?.clientId == "" ? params?.clientId : clientDataJSON?.id,
        tipo: params?.tipo,
        almacen: params?.almacen,
    }));
    callback?.onLoading?.(true);
    (0, fetch_1.fetchWithTimeout)(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
        timeout: 60000,
    })
        .then(response => response?.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                if (json?.reason == api_1.default.REASON_SESSION_EXIPIRED)
                    callback?.onFailSessionExpired?.();
                callback?.onFail?.(json.msg);
                break;
        }
        callback?.onLoading?.(false);
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
        callback?.onLoading?.(false);
    });
};
exports.doCarritoList = doCarritoList;
const doCarritoConfirm = async ({ params, callback }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    const clientDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.CLIENT_DATA);
    const clientDataJSON = JSON.parse(clientDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "save",
        token: loginDataJSON.token,
        cliid: params?.cliid || clientDataJSON?.id,
        //tipo: params?.tipo,
        data: {
            comentario: params?.data?.comentario,
            tipodespacho: params?.data?.tipodespacho,
            direccion: params?.data?.direccion,
            iddireccion: params?.data?.iddireccion,
            transporte: params?.data?.transporte,
            idtransporte: params?.data?.idtransporte,
            direcciontransporte: params?.data?.direcciontransporte,
            idtransportista: params?.data?.idtransportista,
            CodigoMedioTransporte: params?.data?.CodigoMedioTransporte,
            idCotizacion: params?.data?.idCotizacion,
        },
    }));
    callback?.onLoading?.(true);
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response?.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                if (json?.reason == api_1.default.REASON_SESSION_EXIPIRED)
                    callback?.onFailSessionExpired?.();
                callback?.onFail?.(json.msg);
                break;
        }
        callback?.onLoading?.(false);
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
        callback?.onLoading?.(false);
    });
};
exports.doCarritoConfirm = doCarritoConfirm;
const doCarritoAffect = async ({ params, callback }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    const clientDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.CLIENT_DATA);
    const clientDataJSON = JSON.parse(clientDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "carrito",
        token: loginDataJSON.token,
        fnc: model_1.ShoppingCart.FNC_AFFECT,
        cliid: params?.clientId || clientDataJSON?.id,
        tipo: params?.tipo,
        data: {
            procodigo: params?.procodigo,
            cond: params?.cond,
            motivo: params?.motivo,
        },
    }));
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response?.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                if (json?.reason == api_1.default.REASON_SESSION_EXIPIRED)
                    callback?.onFailSessionExpired?.();
                callback?.onFail?.(json.msg);
                break;
        }
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
    });
};
exports.doCarritoAffect = doCarritoAffect;
const doCarritoPrice = async ({ params, callback, }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "carrito",
        token: loginDataJSON?.token,
        fnc: model_1.ShoppingCart.FNC_PRICE,
        cliid: params?.cliid,
        tipo: params?.tipo ?? "ped",
        almacen: params?.almacen,
        data: {
            procodigo: params?.data?.procodigo,
            precio: params?.data?.precio,
        },
    }));
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response?.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                if (json?.reason == api_1.default.REASON_SESSION_EXIPIRED)
                    callback?.onFailSessionExpired?.();
                callback?.onFail?.(json.msg);
                break;
        }
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
    });
};
exports.doCarritoPrice = doCarritoPrice;
const doCarritoDiscounts = async ({ params, callback, }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "carrito",
        token: loginDataJSON?.token,
        fnc: model_1.ShoppingCart.FNC_DISCOUNTS,
        cliid: params?.cliid,
        tipo: params?.tipo ?? "ped",
        data: params?.data,
        alamcen: params?.almacen,
    }));
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response?.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                if (json?.reason == api_1.default.REASON_SESSION_EXIPIRED)
                    callback?.onFailSessionExpired?.();
                callback?.onFail?.(json.msg);
                break;
        }
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
    });
};
exports.doCarritoDiscounts = doCarritoDiscounts;
const doCarritoMerch = async ({ params, callback }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    const clientDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.CLIENT_DATA);
    const clientDataJSON = JSON.parse(clientDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "carrito",
        token: loginDataJSON?.token,
        fnc: model_1.ShoppingCart.FNC_MERCH,
        cliid: params?.cliid || params?.cliid == "" ? params?.cliid : clientDataJSON?.id,
        //tipo: params?.tipo ?? "ped",
        data: params?.data,
    }));
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response?.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                if (json?.reason == api_1.default.REASON_SESSION_EXIPIRED)
                    callback?.onFailSessionExpired?.();
                callback?.onFail?.(json.msg);
                break;
        }
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
    });
};
exports.doCarritoMerch = doCarritoMerch;
const doCarritoSobreDiscount = async ({ params, callback }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    const clientDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.CLIENT_DATA);
    const clientDataJSON = JSON.parse(clientDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "carrito",
        token: loginDataJSON?.token,
        fnc: model_1.ShoppingCart.FNC_SOBRE_DISCOUNT,
        cliid: params?.cliid || params?.cliid == "" ? params?.cliid : clientDataJSON?.id,
        tipo: params?.tipo ?? "ped",
        almacen: params?.almacen,
        data: params?.data,
    }));
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response?.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                if (json?.reason == api_1.default.REASON_SESSION_EXIPIRED)
                    callback?.onFailSessionExpired?.();
                callback?.onFail?.(json.msg);
                break;
        }
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
    });
};
exports.doCarritoSobreDiscount = doCarritoSobreDiscount;
//coti
const doCarritoCotiAdd = async (request) => {
    if (request.params && !request.params?.tipo)
        request.params.tipo = "coti"; //para el carrito de cotización
    doCarritoAdd(request);
};
exports.doCarritoCotiAdd = doCarritoCotiAdd;
const doCarritoCotiRemove = async (request) => {
    if (request.params && !request.params?.tipo)
        request.params.tipo = "coti"; //para el carrito de cotización
    doCarritoRemove(request);
};
exports.doCarritoCotiRemove = doCarritoCotiRemove;
const doCarritoCotiClear = async (request) => {
    if (request.params && !request.params?.tipo)
        request.params.tipo = "coti"; //para el carrito de cotización
    doCarritoClear(request);
};
exports.doCarritoCotiClear = doCarritoCotiClear;
const doCarritoCotiList = async (request) => {
    if (request.params && !request.params?.tipo)
        request.params.tipo = "coti"; //para el carrito de cotización
    doCarritoList(request);
};
exports.doCarritoCotiList = doCarritoCotiList;
const doCarritoCotiPrice = async (request) => {
    if (request.params && !request.params?.tipo)
        request.params.tipo = "coti"; //para el carrito de cotización
    doCarritoPrice(request);
};
exports.doCarritoCotiPrice = doCarritoCotiPrice;
const doCarritoCotiDiscounts = async (request) => {
    if (request.params && !request.params?.tipo)
        request.params.tipo = "coti"; //para el carrito de cotización
    doCarritoDiscounts(request);
};
exports.doCarritoCotiDiscounts = doCarritoCotiDiscounts;
